// extracted by mini-css-extract-plugin
module.exports = {"font-size-name":"20px","statistics":"Statistics_statistics__3yiBv","title":"Statistics_title__1G4A_","statlist":"Statistics_statlist__1FEVr","item":"Statistics_item__1Qnl5"};